export default "__VITE_ASSET__BF03cShD__"